export const LOCAL_TICKET_TRANSITION_EVENT = "estratiza-ticket-transition";

const NESTED_TICKET_RELATIONS = ["contact", "queue", "user", "whatsapp", "company"];

// Eventos de transicao usam um DTO reduzido. Mesclar no estado ja carregado
// evita apagar campos necessarios na tela do ticket (integracao, transferencia,
// configuracao do Whatsapp etc.). null explicito continua significando remocao.
export const mergeRealtimeTicketUpdate = (currentTicket, incomingTicket) => {
  if (!incomingTicket) return currentTicket;

  const merged = { ...(currentTicket || {}), ...incomingTicket };

  NESTED_TICKET_RELATIONS.forEach((relation) => {
    if (!Object.prototype.hasOwnProperty.call(incomingTicket, relation)) return;
    if (incomingTicket[relation] === null) {
      merged[relation] = null;
      return;
    }
    if (typeof incomingTicket[relation] === "object") {
      merged[relation] = {
        ...(currentTicket?.[relation] || {}),
        ...incomingTicket[relation]
      };
    }
  });

  return merged;
};

// FIX-ITEM31-TICKET-TRANSITION-UPDATE: resposta HTTP atualiza a tela mesmo se o socket atrasar.
export const emitLocalTicketTransition = (ticket) => {
  if (!ticket?.id || typeof window === "undefined") return;

  window.dispatchEvent(new CustomEvent(LOCAL_TICKET_TRANSITION_EVENT, {
    detail: { ticket }
  }));
};
